import { h } from 'preact';

export default ({ className = '', hasError, errorLegend, children }) => (
  <div className={`${className || ''}${hasError ? ' invalid' : ''}`}>
    {children}
    {hasError ? <p className="error-feedback">{errorLegend}</p> : null}
  </div>
);



// WEBPACK FOOTER //
// ./components/generics/FieldWrapper.js